import React from 'react';
import Link from 'gatsby-link';
import { Text } from '../Text';
import { Divider } from '../Divider';
import { SmallPostsList } from '../Posts/SmallPostsList';
import { LastStrongWorldText } from '../Text/LastStrongWorldText';
import { SmallArticleCard } from '../Cards/SmallArticleCard';
import styles from './StrongWordTextSection.styles';

/**
 * @param title - title (required)
 * @param subtitle - subtitle (doesn't required)
 * @param posts - posts (required)
 * @param text - text (required)
 * @param styleProps - used as styles properties which component can have
 * @returns {JSX.Element}
 * @constructor
 */

const StrongWordTextSection = ({ title, subtitle, posts, text, className, ...styleProps }) => {
  const { subtitleWidth, subtitleMaxWidth, fontSizeLastWord, lineHeightLastWord } = styleProps;

  return (
    <div className="strong-word-section" css={styles(styleProps)}>
      <div className="strong-word-section__container">
        <div className="strong-word-section__column-first">
          {text ? <Divider height={0} heightMobile={8} /> : <Divider height={0} heightMobile={4} />}
          <LastStrongWorldText
            content={title}
            width={subtitleWidth}
            maxWidth={subtitleMaxWidth}
            fontSize={fontSizeLastWord}
            lineHeight={lineHeightLastWord}
          />
          {subtitle && (
            <div>
              <Divider height={4} heightMobile={'26px'} />
              <Text text={subtitle} width={'100%'} />
            </div>
          )}
        </div>
        <div className="strong-word-section__column-second">
          {text && (
            <div className="strong-word-section__text-container">
              <Text text={text} width={'100%'} />
            </div>
          )}
          {posts && <SmallPostsList posts={posts} lastElement={posts.length < 2} />}
        </div>
        <div className="strong-word-section__merge-columns-block ">
          {posts.length > 1 && (
            <Link to={posts[posts.length - 1].href} className="strong-word-section__navigation-link">
              <SmallArticleCard
                backgroundColor={posts[posts.length - 1].backgroundColor}
                image={posts[posts.length - 1].image}
                mobileImage={posts[posts.length - 1].mobileImage}
                header={posts[posts.length - 1].description}
                logo={posts[posts.length - 1].logo}
                sponsorBar={posts[posts.length - 1].sponsorBar}
                className={className}
              />
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default StrongWordTextSection;
